import { ButtonProps } from '../Button';
import { TPAComponentProps } from '../../types';

export interface StatesButtonProps extends ButtonProps, TPAComponentProps {
  state: StatesButtonStates;
  disabled?: boolean;
  idleContent: string | React.ReactElement;
  failureContent?: string | React.ReactElement;
  inProgressContent?: string | React.ReactElement;
  successContent?: string | React.ReactElement;
  /** A callback that will run 2 seconds after entering success/failure mode. This is usually used to trigger a change back to idle state. */
  onNotificationEnd?: Function;
}

export enum StatesButtonStates {
  IDLE = 'IDLE',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}
